// Devuelve verdadero si el elemento tiene como padre a uno de los elementos
// indicados en el arreglo por tagName o clase
export const isChildOf = (element: HTMLElement, ...elements: string[]): boolean => {
  while (element !== null && element.tagName.toLowerCase() !== 'body') {
    if (elements.some(
      currentElement => currentElement.toLowerCase() === element.tagName.toLowerCase() ||
      Array.from(element.classList).some(currentClass => currentClass.toLowerCase() === currentElement.toLowerCase()),
    ))
      return true;
    element = element.parentNode as HTMLElement;
  }
  return false;
};

// Si el valor indicado es una variable css, lo devuelve formateado como tal
export const cssValue = (value: string | number | undefined): string | undefined => {
  if (typeof value === 'string') {
    value = value.trim();
    let match = value.match(/(?<!\()--[^\s;]+/);
    while (match) {
      value = value.replaceAll(match[0], `var(${ match[0] })`);
      match = value.match(/(?<!\()--[^\s;]+/);
    }
  }
  return typeof value === 'number' ? value.toString() : value;
};
